<template>
  <v-layout text-xs-center row wrap>
    <v-flex>
      <img v-if="value" :src="value" style="max-width: 300px; max-height: 300px;"/>
      <v-container v-if="!value" fill-height justify-center>
        <v-icon x-large>panorama</v-icon> No image
      </v-container>
    </v-flex>
    <v-flex :xs4="!actionsBottom" :xs12="!!actionsBottom">
      <CropDialog v-if="image" v-model="image" :suggest="suggest" :aspect-ratio="aspectRatio"></CropDialog>
      <v-btn v-on:click="selector = true">Choose</v-btn>
      <v-btn v-if="!disableClear" v-on:click="clear">Clear</v-btn>
    </v-flex>
    <ImageSelector v-model="selector" :suggest="suggest" v-on:select="$emit('input', $event)"/>
  </v-layout>
</template>

<script>
import ImageSelector from './ImageSelector'
import CropDialog from './CropDialog'

export default {
  components: { ImageSelector, CropDialog },
  props: ['value', 'suggest', 'actionsBottom', 'disableClear', 'aspectRatio'],
  data () {
    return {
      selector: false
    }
  },
  computed: {
    image: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    clear () {
      if (!confirm(`Вы уверены что хотите удалить картинку?`)) {
        return
      }
      this.$emit('input', null)
    }
  }
}
</script>

<style scoped>

</style>
